import React from "react";
import moment, { type Moment } from "moment";
import Button from "../../Buttons/Button";

type Props = {
    year: Moment;
    start: Moment | null;
    end: Moment | null;
    range: boolean;
    onClick: (value: Moment) => void;
};

export default class MonthPickerYear extends React.Component<Props> {
    public months = moment.monthsShort();

    public onMonthClick = (month: string) => {
        return (e: React.MouseEvent<HTMLButtonElement>): void => {
            e.stopPropagation();
            this.props.onClick(
                this.props.year.clone()
                    .month(month)
                    .startOf("month")
            );
        };
    };

    public render(): React.ReactNode {
        const year = this.props.year.format("YYYY");
        const current = moment().format("YYYY MMM");

        return (
            <div className="calendar-month-picker-year">
                <div className="calendar-month-picker-year-header">
                    {year}
                </div>
                <div className="calendar-month-picker-year-months">
                    {this.months.map(month => {
                        const classes = [ "calendar-month-picker-year-month" ];

                        if(current === `${year} ${month}`) {
                            classes.push("today");
                        }

                        return (
                            <Button
                                key={`${year}|${month}`}
                                type="button"
                                classes={classes}
                                onClick={this.onMonthClick(month)}
                            >
                                {month}
                            </Button>
                        );
                    })}
                </div>
            </div>
        );
    }
}
